const css = `._header_29045_1 {
  align-items: center;
  background-color: var(--bg-color);
  border-bottom: 1px solid var(--border-color);
  display: grid;
  column-gap: 16px;
  min-height: 48px;
  padding-left: 16px;
  position: sticky;
  top: 0;
  z-index: 100;
  grid-template-columns: 180px auto 128px;
  grid-template-areas: "Logo Nav Controls";
}
@media (max-width: 767px) {
  ._header_29045_1 {
    grid-template-columns: 180px auto 48px;
    grid-template-areas: "Logo . MobileMenuButton";
  }
}
._header_29045_1:after {
  background-color: var(--secondary-border-color);
  content: "";
  height: 1px;
  left: 0;
  position: absolute;
  bottom: -1px;
  z-index: 99;
}
._headerLogo_29045_30 {
  align-items: center;
  color: var(--text-color);
  display: flex;
  grid-area: Logo;
  min-height: 48px;
  z-index: 100;
}
._headerLogo_29045_30 a {
  color: var(--text-color);
}
._headerLogo_29045_30 svg {
  fill: currentColor;
  height: auto;
  width: 100%;
}
._headerNav_29045_46 {
  column-gap: 16px;
  display: flex;
  grid-area: Nav;
}
._headerNav_29045_46 > a, ._headerNav_29045_46 > button {
  color: inherit;
  font-size: 0.8em;
  text-transform: uppercase;
}
@media (max-width: 767px) {
  ._headerNav_29045_46 {
    display: none;
  }
}
._headerControls_29045_61 {
  grid-area: Controls;
}
._headerControls_29045_61 > button {
  border: 0 none transparent;
  border-left: 1px solid var(--border-color);
  width: 100%;
}
._headerControls_29045_61 > button[data-size=medium] {
  padding: 16px 8px;
}
@media (max-width: 767px) {
  ._headerControls_29045_61 {
    display: none;
  }
}
._headerMobileMenuButton_29045_77 {
  display: none;
  grid-area: MobileMenuButton;
}
@media (max-width: 767px) {
  ._headerMobileMenuButton_29045_77 {
    display: flex;
  }
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "header": "_header_29045_1",
  "headerLogo": "_headerLogo_29045_30",
  "headerNav": "_headerNav_29045_46",
  "headerControls": "_headerControls_29045_61",
  "headerMobileMenuButton": "_headerMobileMenuButton_29045_77"
};